import { put, takeLatest } from 'redux-saga/effects';
import quickbuyApi from "../services/quickbuyApi";
import {
    FOLIO_LIST_KARVY_RESPONSE, FOLIO_LIST_KARVY_FAILED, GET_REGISTERED_BANKS_RESPONSE, GET_REGISTERED_BANKS_FAILED, ORDER_GENERATION_RESPONSE, ORDER_GENERATION_FAILED,
    PAYMENT_REQUEST_RESPONSE, PAYMENT_REQUEST_FAILED, GET_PG_RESPONSE_RESPONSE, GET_PG_RESPONSE_FAILED, VALIDATE_BROKER_CODE_RESPONSE, VALIDATE_BROKER_CODE_FAILED,
    FOLIO_BROKER_LIST_RESPONSE, FOLIO_BROKER_LIST_FAILED, BUCKET_ID, DIT_URL_DETAILS, SELECTED_OPTION
} from '../redux/types/quickbuy';
import { getDecryptedItem } from '../helper/methods';
let api = new quickbuyApi();

export function* FolioListKarvy({ payload, resolve }) {
    let responsePayload = {};
    let folioNolist = {};
    let responsePayloadLoader = { start: true, stop: false };
    try {
        // yield put({ type: START_LOADING_RESPONSE, payload: responsePayloadLoader })
        let { data } = yield api.FolioListKarvy(payload);
        responsePayloadLoader = { start: false, stop: true };
        if (data?.success) {
            // yield put({ type: FINISH_LOADING_RESPONSE, payload: responsePayloadLoader })
            let responseData = data.data;
            responseData = responseData?.filter(item => item?.dematAccount === false);
            // foliolist=responseData
            let holdingList = [...new Set(responseData.map(a => a.holdingMode))];
            holdingList.forEach((name) => {
                let responseHoldingList = responseData.filter((item) => { return item.holdingMode == name });
                folioNolist[name] = formatfolioNoList(responseHoldingList);

            })
            // let userType = responseData && responseData[0]?.invCategory;
            // localStorage.setItem("userType", userType);
            // console.log("userType", userType);
            const userInfo = getDecryptedItem("userInfo");
            if (userInfo?.nriFlag?.toUpperCase() === "TRUE") {
                localStorage.setItem("userType", "NRI-REPATRIABLE");
            }

            responsePayload.holdingList = formatholdingModelist(holdingList);
            responsePayload.folioNolist = folioNolist
            yield put({ type: FOLIO_LIST_KARVY_RESPONSE, payload: responsePayload, })
            resolve && resolve(data.data)
        }
        else {
            resolve && resolve(data)
            // yield put({ type: FINISH_LOADING_RESPONSE, payload: responsePayloadLoader })
            yield put({ type: FOLIO_LIST_KARVY_FAILED, payload: responsePayload })
            // responsePayload = { open: true, severity: "error", message: message }
        }
    } catch (e) {
        yield put({ type: FOLIO_LIST_KARVY_FAILED, payload: responsePayload })

    }
}
export function* GetRegisteredBanks({ payload, resolve }) {
    let responsePayload = {};
    let sectionAllocation = [];
    let responsePayloadLoader = { start: true, stop: false };
    try {
        // yield put({ type: START_LOADING_RESPONSE, payload: responsePayloadLoader })
        let { data } = yield api.GetRegisteredBanks(payload);
        responsePayloadLoader = { start: false, stop: true };
        if (data?.success) {
            // yield put({ type: FINISH_LOADING_RESPONSE, payload: responsePayloadLoader })
            let responseData = data.data;
            yield put({ type: GET_REGISTERED_BANKS_RESPONSE, payload: responsePayload, })
            resolve && resolve(data.data)
        }
        else {
            resolve && resolve(data)
            // yield put({ type: FINISH_LOADING_RESPONSE, payload: responsePayloadLoader })
            yield put({ type: GET_REGISTERED_BANKS_FAILED, payload: responsePayload })
            // responsePayload = { open: true, severity: "error", message: message }
        }
    } catch (e) {
        yield put({ type: GET_REGISTERED_BANKS_FAILED, payload: responsePayload })

    }
}
export function* OrderGeneration({ payload, resolve }) {
    let responsePayload = {};
    let sectionAllocation = [];
    let responsePayloadLoader = { start: true, stop: false };
    try {
        // yield put({ type: START_LOADING_RESPONSE, payload: responsePayloadLoader })
        let { data } = yield api.OrderGeneration(payload);
        responsePayloadLoader = { start: false, stop: true };
        if (data?.success) {
            // yield put({ type: FINISH_LOADING_RESPONSE, payload: responsePayloadLoader })
            let responseData = data.data;

            yield put({ type: ORDER_GENERATION_RESPONSE, payload: responsePayload, })
            resolve && resolve(data.data)
        }
        else {
            resolve && resolve(data)
            // yield put({ type: FINISH_LOADING_RESPONSE, payload: responsePayloadLoader })
            yield put({ type: ORDER_GENERATION_FAILED, payload: responsePayload })
            // responsePayload = { open: true, severity: "error", message: message }
        }
    } catch (e) {
        yield put({ type: ORDER_GENERATION_FAILED, payload: responsePayload })

    }
}
export function* PaymentRequest({ payload, resolve }) {
    let responsePayload = {};
    let sectionAllocation = [];
    let responsePayloadLoader = { start: true, stop: false };
    try {
        // yield put({ type: START_LOADING_RESPONSE, payload: responsePayloadLoader })
        let { data } = yield api.PaymentRequest(payload);
        responsePayloadLoader = { start: false, stop: true };
        if (data?.success) {
            // yield put({ type: FINISH_LOADING_RESPONSE, payload: responsePayloadLoader })
            let responseData = data.data;
            yield put({ type: PAYMENT_REQUEST_RESPONSE, payload: responsePayload, })
            resolve && resolve(data.data)
        }
        else {
            resolve && resolve(data)
            // yield put({ type: FINISH_LOADING_RESPONSE, payload: responsePayloadLoader })
            yield put({ type: PAYMENT_REQUEST_FAILED, payload: responsePayload })
            // responsePayload = { open: true, severity: "error", message: message }
        }
    } catch (e) {
        yield put({ type: PAYMENT_REQUEST_FAILED, payload: responsePayload })

    }
}
export function* GetPGResponse({ payload, resolve }) {
    let responsePayload = {};
    let sectionAllocation = [];
    let responsePayloadLoader = { start: true, stop: false };
    try {
        // yield put({ type: START_LOADING_RESPONSE, payload: responsePayloadLoader })
        let { data } = yield api.GetPGResponse(payload);
        responsePayloadLoader = { start: false, stop: true };
        if (data?.success) {
            // yield put({ type: FINISH_LOADING_RESPONSE, payload: responsePayloadLoader })
            let responseData = data.data;

            yield put({ type: GET_PG_RESPONSE_RESPONSE, payload: responsePayload, })
            resolve && resolve(data.data)
        }
        else {
            resolve && resolve(data)
            // yield put({ type: FINISH_LOADING_RESPONSE, payload: responsePayloadLoader })
            yield put({ type: GET_PG_RESPONSE_FAILED, payload: responsePayload })
            // responsePayload = { open: true, severity: "error", message: message }
        }
    } catch (e) {
        yield put({ type: GET_PG_RESPONSE_FAILED, payload: responsePayload })

    }
}
export function* validateBrokerCode({ payload, resolve }) {
    let responsePayload = {};
    let sectionAllocation = [];
    let responsePayloadLoader = { start: true, stop: false };
    try {
        // yield put({ type: START_LOADING_RESPONSE, payload: responsePayloadLoader })
        let { data } = yield api.validateBrokerCode(payload);
        responsePayloadLoader = { start: false, stop: true };
        if (data?.success) {
            // yield put({ type: FINISH_LOADING_RESPONSE, payload: responsePayloadLoader })
            let responseData = data.data;

            yield put({ type: VALIDATE_BROKER_CODE_RESPONSE, payload: responsePayload, })
            resolve && resolve(data.data)
        }
        else {
            resolve && resolve(data)
            // yield put({ type: FINISH_LOADING_RESPONSE, payload: responsePayloadLoader })
            yield put({ type: VALIDATE_BROKER_CODE_FAILED, payload: responsePayload })
            // responsePayload = { open: true, severity: "error", message: message }
        }
    } catch (e) {
        yield put({ type: VALIDATE_BROKER_CODE_FAILED, payload: responsePayload })

    }
}
export function* folioBrokerList({ payload, resolve }) {
    let responsePayload = {};
    let sectionAllocation = [];
    let responsePayloadLoader = { start: true, stop: false };
    try {
        // yield put({ type: START_LOADING_RESPONSE, payload: responsePayloadLoader })
        let { data } = yield api.folioBrokerList(payload);
        responsePayloadLoader = { start: false, stop: true };
        if (data?.success) {
            // yield put({ type: FINISH_LOADING_RESPONSE, payload: responsePayloadLoader })
            let responseData = data.data;
            // responsePayload.brokerCode = responseData[0].brokerCode;
            // responsePayload.brokerName = responseData[0].brokerName;
            // responsePayload.subbrokerCode = responseData[0].subbrokerCode;
            // responsePayload.riaCode = responseData[0].riaCode;
            // responsePayload.folio = responseData[0].folio
            yield put({ type: FOLIO_BROKER_LIST_RESPONSE, payload: responsePayload })
            resolve && resolve(responseData)
        }
        else {
            resolve && resolve(data)
            // yield put({ type: FINISH_LOADING_RESPONSE, payload: responsePayloadLoader })
            yield put({ type: FOLIO_BROKER_LIST_FAILED, payload: responsePayload })
            // responsePayload = { open: true, severity: "error", message: message }
        }
    } catch (e) {
        yield put({ type: FOLIO_BROKER_LIST_FAILED, payload: responsePayload })

    }
}
function formatholdingModelist(data) {
    let processedList = data.map((holdingMode) => {
        return { label: holdingMode, value: holdingMode }
    })
    return processedList;
}
function formatfolioNoList(data) {
    let processedList = data.map(({ foliono, holderName, invCategory }) => {
        return { label: foliono, value: foliono, holderName: holderName, userType: invCategory }
    })
    return processedList;
}

export function* getBucketID(data) {
    // yield takeLatest(BUCKET_ID, data)
    yield put({ type: BUCKET_ID, payload: data })
}

export function* dit_URLDetails(data) {
    yield put({ type: DIT_URL_DETAILS, payload: data })
}

export function* selectedOption(data) {
    yield put({ type: SELECTED_OPTION, payload: data })
}